import { render, staticRenderFns } from "./ProfileLocation.vue?vue&type=template&id=49c848f2&scoped=true&"
import script from "./ProfileLocation.vue?vue&type=script&lang=js&"
export * from "./ProfileLocation.vue?vue&type=script&lang=js&"
import style0 from "./ProfileLocation.vue?vue&type=style&index=0&id=49c848f2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c848f2",
  null
  
)

export default component.exports